export default "__VITE_ASSET__jUybmqvp__"